import React from 'react'

import { useAppSelector } from '@/utils/hooks'
import { RootState } from '@/redux/store'

import TopMenuLayout from '@/components/layout/TopMenuLayout'
import SideMenuLayout from '@/components/layout/SideMenuLayout'
import { layoutConfig } from '@/utils/consts'

interface LayoutFactoryProps {
  routes: Routes
}

const LayoutFactory: React.FC<LayoutFactoryProps> = ({ routes }) => {
  const { uiConfig } = useAppSelector((state: RootState) => state.app)

  const renderLayoutByUIConfig = () => {
    switch (uiConfig.menuBarLayout) {
      case layoutConfig.top:
        return <TopMenuLayout routes={routes} />

      case layoutConfig.side:
        return <SideMenuLayout routes={routes} />

      default:
        return <TopMenuLayout routes={routes} />
    }
  }

  return renderLayoutByUIConfig()
}

export default LayoutFactory
